const res =
  "https://dna-run-public.s3.us-east-2.amazonaws.com/trails-resources";

// bolt.png
// fire.png
// glass_shards_1.png
// glass_shards_2.png
// glass_shards_3.png
// glass_shards_4.png
// grad-particle.png
// pinkdust.png
//
export const Trails_ResourceMap = {
  fire: `${res}/fire.png`,
  glass_shards_1: `${res}/glass_shards_1.png`,
  glass_shards_2: `${res}/glass_shards_2.png`,
  glass_shards_3: `${res}/glass_shards_3.png`,
  glass_shards_4: `${res}/glass_shards_4.png`,
  grad_particle: `${res}/grad-particle.png`,
  pinkdust: `${res}/pinkdust.png`,
  bolt: `${res}/bolt.png`,
};

const prew = "https://dna-run-public.s3.us-east-2.amazonaws.com/trails-preview";

// "crystal_red",
// "crystal_cyan",
// "crystal_green",
// "crystal_yellow",
// "crystal_rainbow1",
// "crystal_rainbow2",
//
// "glass_red",
// "glass_cyan",
// "glass_green",
// "glass_yellow",
// "glass_rainbow1",
// "glass_rainbow2",
//
// "fire2",
// "smoke",
// "smoke_rainbow1",
// "bolts",

export const Trails_PreviewMap = {
  crystal_red: [`Crystal Red`, `${prew}/crystal_red.jpg`],
  crystal_cyan: [`Crystal Cyan`, `${prew}/crystal_cyan.jpg`],
  crystal_green: [`Crystal Green`, `${prew}/crystal_green.jpg`],
  crystal_yellow: [`Crystal Yellow`, `${prew}/crystal_yellow.jpg`],
  crystal_rainbow1: [`Crystal Rainbow1`, `${prew}/crystal_rainbow1.jpg`],
  crystal_rainbow2: [`Crystal Rainbow2`, `${prew}/crystal_rainbow2.jpg`],

  glass_red: [`Glass Red`, `${prew}/glass_red.jpg`],
  glass_cyan: [`Glass Cyan`, `${prew}/glass_cyan.jpg`],
  glass_green: [`Glass Green`, `${prew}/glass_green.jpg`],
  glass_yellow: [`Glass Yellow`, `${prew}/glass_yellow.jpg`],
  glass_rainbow1: [`Glass Rainbow1`, `${prew}/glass_rainbow1.jpg`],
  glass_rainbow2: [`Glass Rainbow2`, `${prew}/glass_rainbow2.jpg`],

  fire2: [`Fire`, `${prew}/fire2.jpg`],
  smoke: [`Smoke`, `${prew}/smoke.jpg`],
  smoke_rainbow1: [`Smoke Rainbow1`, `${prew}/smoke_rainbow1.jpg`],
  bolts: [`Bolts`, `${prew}/bolts.jpg`],
};
